import { h } from "preact";
import { calculateForeground } from "../internal_utilities/utilities";

const HighlightedTitle = props => {
  const wordReplacer = (sourceText, dataMap) => {
    let text = sourceText;
    dataMap.map(item => {
      text = text.replace(
        item.placeholder,
        `<span
        style='background:${props.color} !important; color: ${
          calculateForeground(props.color) === "white"
            ? "rgba(255,255,255,1)"
            : "rgba(0,0,0,.6)"
        } !important;padding: 2px 8px!important;border-radius: 4px !important;white-space: nowrap ;'>${
          item.value
        }</span>`
      );
    });
    return text;
  };
  return (
    <span
      dangerouslySetInnerHTML={{
        __html: wordReplacer(props.text, props.wordMap)
      }}
    />
  );
};

export default HighlightedTitle;
